<template>
  <!--新增组 -->
  <app-dialog2 ref="dialog" title="临时登录链接" :width="900">
    <app-status ref="page" class="appDetail">
      <el-form-item prop="goodsName" v-if="showTime" style="width: 500px">
        <el-input placeholder="请输入登录时长" v-model="loginTime">
          <template #append>
            <el-button type="primary"> 单位(分)</el-button>
          </template>
        </el-input>
      </el-form-item>
      <div v-else>
        <div class="payAttention">注意：链接只在一分钟内有效</div>
        <div class="link">{{ linkedData }}</div>
      </div>
      <div class="appDetail-footer">
        <div class="appDetail-buttongourp">
          <el-button @click="$refs.dialog.close()" type="primary" plain class="appDetail-buttongourp-button"> 取消 </el-button>
          <el-button type="primary" @click="temporaryLogin" class="appDetail-buttongourp-button" v-if="showTime"> 确定</el-button>
        </div>
      </div>
    </app-status>
  </app-dialog2>
</template>

<script>
import { mapState } from 'vuex';
export default {
  emits: ['confirm'],

  data() {
    return {
      data: '',
      authData: '',
      linkedData: '',
      loginTime: 120,
      showTime: true,
    };
  },
  computed: {
    ...mapState('auth', ['userInfo']),
    ...mapState('user', ['userInfo']),
  },
  methods: {
    /**
     * 打开弹框
     */
    async open() {
      // 打开弹框
      await this.$refs.dialog.open();
      // await this.temporaryLogin();
    },

    async temporaryLogin() {
      if (this.loginTime == '') {
        this.$message.error('请输入时间');
        return;
      }
      try {
        const result = await this.$request.get('/auth/temp-login-code', {
          params: {
            ttl: this.loginTime,
          },
        });
        this.showTime = false;
        const locationList = location.host;
        if (process.env.NODE_ENV == 'TEST') {
          console.log('测试');
          this.linkedData = locationList + '/index.html#/login?loginCode=' + result.data;
        } else {
          console.log('正式 本地');
          this.linkedData = locationList + '/login?loginCode=' + result.data;
        }
        this.$message.success('成功生成临时登录链接');
      } catch (e) {
        this.$refs.page.status('error', e.message);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.link {
  margin-bottom: 20px;
  font-size: 16px;
}

.payAttention {
  color: red;
  font-size: 12px;
  margin-bottom: 10px;
}
</style>
